import React from "react";
import { NavLink } from "react-router-dom";

import PropTypes from "prop-types";

const cityFormat = (address, numberOfInfo = 2) => {
  let city = "";
  if (address && address.admin3) {
    city += `${address.admin3.replace("Comune di ", "")}`;
  } else if (address && address.admin2) {
    city += `${address.admin2}`;
  } else if (address && address.admin1) {
    city += `${address.admin1}`;
  }
  if (address && address.city && city !== `${address.city}`) {
    if (numberOfInfo === 2 && city !== "") {
      city += `, ${address.city}`;
    } else if (city === "") {
      city += `${address.city}`;
    }
  }
  return city;
};

const getScore = (restaurant, type) => {
  if (restaurant[`score${type}`] && !isNaN(restaurant[`score${type}`])) {
    if (restaurant[`score${type}`] === 10) {
      return 10;
    }
    return restaurant[`score${type}`].toFixed(1);
  }
  return "-";
};

const getCertification = () => {
  return (
    <div className="search-results-card-certification">
      <i className="icon icon-cockade-24" />
    </div>
  );
};

export default function SearchRestaurantCard(props) {
  const restaurant = props.restaurant;
  let image = "";
  if (
    restaurant.viewStyleSelected &&
    restaurant.viewStyleSelected.enable &&
    restaurant.viewStyleSelected.url &&
    !restaurant.viewStyleSelected.random
  ) {
    image = restaurant.viewStyleSelected.url;
  } else if (restaurant.photos && restaurant.photos.length > 0) {
    image = restaurant.photos[0].url;
  } else if (restaurant.photos && restaurant.photos.url) {
    image = restaurant.photos.url;
  } else {
    image = restaurant.viewStyleSelected.url;
  }
  let score = getScore(restaurant, "Overall");
  if (
    (!restaurant.scoreOverall || Number(restaurant.scoreOverall) < 1) &&
    restaurant.facebook &&
    restaurant.facebook.overall_star_rating
  ) {
    score = Number(restaurant.facebook.overall_star_rating) * 2;
  }
  let checkInNumber = "";
  let checkInLabel = "checkins";
  if (restaurant.checkInNumber && Number(restaurant.checkInNumber) > 0) {
    checkInNumber = restaurant.checkInNumber;
    if (
      restaurant.facebook &&
      restaurant.facebook.rating_count &&
      Number(restaurant.facebook.rating_count) > 0
    ) {
      checkInLabel = "esperienze";
      checkInNumber =
        Number(restaurant.checkInNumber) +
        Number(restaurant.facebook.rating_count);
    }
  } else if (
    restaurant.facebook &&
    restaurant.facebook.rating_count &&
    Number(restaurant.facebook.rating_count) > 0
  ) {
    checkInNumber = restaurant.facebook.rating_count;
    // checkInLabel = t('experiences').substr(0, 3);
    checkInLabel = "esperienze";
  }
  const categoryLabel = [];
  // console.log('restaurant.categories', restaurant.categories);
  restaurant.categories.forEach(category => {
    categoryLabel.push(category.label_it);
  });
  // let VisibilitySensor;
  // let Sensor = null;
  // if (this.state.VisibilitySensor !== null) {
  //   VisibilitySensor = this.state.VisibilitySensor;
  //   Sensor = (
  //     <VisibilitySensor
  //       onChange={isVisible => {
  //         this.props.onVisibilityChange(isVisible, this.props.pinNumber);
  //       }}
  //       intervalDelay={0}
  //     />
  //   );
  // }
  // let selected = false;
  // if (this.props.pinStatus === "selected") {
  //   selected = true;
  // }
  let foodTypes = "";
  // console.log('restaurant.foodTypes', restaurant.typesOfFood);
  if (
    restaurant.typesOfFood &&
    restaurant.typesOfFood.length > 0 &&
    props.attributes &&
    props.attributes.foodTypes
  ) {
    if (restaurant.typesOfFood[0][`label_it`]) {
      foodTypes += restaurant.typesOfFood[0][`label_it`];
    } else {
      const type = this.props.attributes.foodTypes.find(
        food => food._id === restaurant.typesOfFood[0]
      );
      if (type && type[`label_it`]) {
        foodTypes += type[`label_it`];
      }
    }
  }
  if (
    restaurant.typesOfFood &&
    restaurant.typesOfFood.length > 1 &&
    props.attributes &&
    props.attributes.foodTypes
  ) {
    if (restaurant.typesOfFood[1][`label_it`]) {
      foodTypes += ", ";
      foodTypes += restaurant.typesOfFood[1][`label_it`];
    } else {
      const type = props.attributes.foodTypes.find(
        food => food._id === restaurant.typesOfFood[1]
      );
      if (type && type[`label_it`]) {
        foodTypes += ", ";
        foodTypes += type[`label_it`];
      }
    }
  }
  let price = "";
  if (
    restaurant.price &&
    restaurant.price.value &&
    !isNaN(restaurant.price.value)
  ) {
    price = `${Number(restaurant.price.value).toFixed(0)}€`;
  }
  let city = "";
  if (restaurant[`addressIT`]) {
    city = cityFormat(restaurant[`addressIT`]);
  }
  return (
    <div className="search-results-card">
      <NavLink
        to={`/restaurant?${restaurant.alias}`}
        // className={classes.itemLink + " " + classes.userCollapseLinks}
        className="user-menu-link"
      >
        <div
          className="search-results-card-image"
          style={{ backgroundImage: `url('${image}')` }}
        />
      </NavLink>

      {/* <a title={restaurant.name} href={}>
        <div
          className="search-results-card-image"
          style={{ backgroundImage: `url('${image}')` }}
        />
      </a> */}
      <div className="search-results-card-data">
        <div className="search-results-card-category">
          {restaurant.categories[0][`label_it`]}
        </div>
        <NavLink
          to={`/restaurant?${restaurant.alias}`}
          // className={classes.itemLink + " " + classes.userCollapseLinks}
          className="user-menu-link"
        >
          <h2 className="search-results-card-name line-clamp line-clamp-2">
            {restaurant.name}
          </h2>
        </NavLink>
        {/* <a title={restaurant.name} href={`/restaurant?${restaurant.alias}`}></a> */}
        <div className="search-results-card-foodTypes">{foodTypes}</div>
        {price && price.length > 0 ? (
          <div className="search-results-card-price">
            {"prezzo"} {price}
          </div>
        ) : null}
        <h4 className="search-results-card-city line-clamp line-clamp-1">
          {city}
        </h4>
        {(restaurant.scoreOverall && !isNaN(restaurant.scoreOverall)) ||
        (restaurant.checkInNumber && Number(restaurant.checkInNumber) > 0) ||
        (restaurant.facebook && restaurant.facebook.overall_star_rating) ||
        (restaurant.facebook &&
          restaurant.facebook.rating_count &&
          Number(restaurant.facebook.rating_count) > 0) ? (
          <div className="search-results-card-score-container">
            {((restaurant.scoreOverall && !isNaN(restaurant.scoreOverall)) ||
              (restaurant.facebook &&
                restaurant.facebook.overall_star_rating)) &&
            score ? (
              <div className="search-results-card-score">{score}</div>
            ) : (
              <div className="search-results-card-score">{"-"}</div>
            )}
            {(restaurant.checkInNumber &&
              Number(restaurant.checkInNumber) > 0) ||
            (restaurant.facebook &&
              restaurant.facebook.rating_count &&
              Number(restaurant.facebook.rating_count) > 0) ? (
              <div className="search-results-card-checkins-number">
                <span style={{ fontSize: "16px" }}>{checkInNumber}</span>
                <br />
                {checkInLabel}
              </div>
            ) : null}
          </div>
        ) : null}
        {restaurant.certificationRequest &&
        restaurant.certificationRequest.status === "fulfilled"
          ? getCertification()
          : null}
      </div>
    </div>
  );
}

SearchRestaurantCard.propTypes = {
  restaurant: PropTypes.object,
  attributes: PropTypes.object
};
